import moment from 'moment-timezone';

const ONE_DAY = 24 * 60 * 60;
const ONE_HOUR = 60 * 60;
const ONE_MINUTE = 60;

export function getCurrentTimezone() {
    const tz = moment.tz.guess();
    return getTimezoneObject(tz);
}

export function getMomentDate(timestamp, timezone) {
    if (!timestamp) {
        return moment.utc().tz(timezone || getCurrentTimezone().name);
    }
    return moment.utc(+timestamp).tz(timezone || getCurrentTimezone().name);
}

export function getTimezoneOffset(timezone) {
    const zone = moment.tz.zone(timezone || getCurrentTimezone().name);
    const currentTimezone = moment.tz.zone(getCurrentTimezone().name);
    if (zone) return (zone.offsets[0] - currentTimezone.offsets[0]) * 60 * 1000;
    return 0;
}

export function getTimezonesList() {
    const timezones = moment.tz.names();
    return timezones.map(getTimezoneObject).sort((a, b) => {
        const aTime = a.displayName.match(/GMT([+-]\d\d):(\d\d)/);
        const bTime = b.displayName.match(/GMT([+-]\d\d):(\d\d)/);
        return parseInt(aTime[1] + aTime[2], 10) - parseInt(bTime[1] + bTime[2], 10);
    });
}

export function getTimezoneObject(tz) {
    if (!tz) return {};

    return {
        name: tz,
        displayName: getTimezoneDisplayName(tz),
    };
}

export function getTimezoneDisplayName(tz) {
    return `${tz} (${moment.tz(tz).format('[GMT]Z, z')})`;
}

export function renderPeriod(time, elements) {
    const periods = {};
    periods.days = _normalizeTime(Math.floor(time / ONE_DAY));
    periods.hours = _normalizeTime(Math.floor(time % ONE_DAY / ONE_HOUR));
    periods.minutes = _normalizeTime(Math.floor(time % ONE_HOUR / ONE_MINUTE));
    periods.seconds = _normalizeTime(Math.floor(time % ONE_HOUR % ONE_MINUTE));
    let result = '';
    const keys = Object.keys(elements);
    keys.forEach((key) => {
        switch (key) {
        case 'days':
            if (periods[key] > 0) result += `${periods[key]}d`;
            break;
        case 'hours':
            result += ` ${periods[key]}`;
            break;
        default:
            result += `:${periods[key]}`;
            break;
        }
    });
    return result;
}

function _normalizeTime(time) {
    return time.toString().length === 1 ? `0${time}` : time;
}



// WEBPACK FOOTER //
// ./src/sources/timezone/timeHelper.js